//GameOn.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import './GameOn.css';
import './MineSweeper.css';
// import gameonimage from '../../assets/pageimages/gameonimage.png';

const numRows = 10;
const numCols = 10;
const numMines = 10;

const generateEmptyGrid = () => {
  const grid = [];
  for (let i = 0; i < numRows; i++) {
    grid.push(Array(numCols).fill({ value: 0, revealed: false, flagged: false }));
  }
  return grid;
};

const generateRandomMines = () => {
  const mines = [];
  while (mines.length < numMines) {
    const row = Math.floor(Math.random() * numRows);
    const col = Math.floor(Math.random() * numCols);
    if (!mines.some(mine => mine[0] === row && mine[1] === col)) {
      mines.push([row, col]);
    }
  }
  return mines;
};

function GameOnMineSweeper() {
  const [grid, setGrid] = useState(generateEmptyGrid());
  const [mines, setMines] = useState(generateRandomMines());
  const [gameOver, setGameOver] = useState(false);
  const [win, setWin] = useState(false);

  useEffect(() => {
    const newGrid = [...grid];
    mines.forEach(([row, col]) => {
      newGrid[row][col].value = 'X';
    });
    setGrid(newGrid);
  }, []);

  const handleCellClick = (row, col) => {
    if (gameOver || grid[row][col].revealed || grid[row][col].flagged) return;

    const newGrid = [...grid];

    if (newGrid[row][col].value === 'X') {
      // Game over, reveal all mines
      newGrid.forEach(row => row.forEach(cell => cell.revealed = true));
      setGameOver(true);
      return;
    }

    // Recursive function to reveal adjacent cells
    const revealAdjacent = (row, col) => {
      if (row < 0 || row >= numRows || col < 0 || col >= numCols) return;
      if (newGrid[row][col].revealed || newGrid[row][col].flagged) return;

      newGrid[row][col].revealed = true;

      if (newGrid[row][col].value === 0) {
        revealAdjacent(row - 1, col - 1);
        revealAdjacent(row - 1, col);
        revealAdjacent(row - 1, col + 1);
        revealAdjacent(row, col - 1);
        revealAdjacent(row, col + 1);
        revealAdjacent(row + 1, col - 1);
        revealAdjacent(row + 1, col);
        revealAdjacent(row + 1, col + 1);
      }
    };

    revealAdjacent(row, col);
    setGrid(newGrid);

    // Check win condition
    const revealedCount = newGrid.reduce((count, row) => {
      return count + row.filter(cell => cell.revealed).length;
    }, 0);
    if (revealedCount === numRows * numCols - numMines) {
      setWin(true);
      setGameOver(true);
    }
  };

  const handleFlagClick = (row, col) => {
    if (gameOver || grid[row][col].revealed) return;

    const newGrid = [...grid];
    newGrid[row][col].flagged = !newGrid[row][col].flagged;
    setGrid(newGrid);
  };

  const handleStartAgain = () => {
    setGrid(generateEmptyGrid());
    setMines(generateRandomMines());
    setGameOver(false);
    setWin(false);
  };

  const renderGrid = () => {
    return grid.map((row, i) => (
      <div key={i} className="row">
        {row.map((cell, j) => (
          <div
            key={`${i}-${j}`}
            className={`cell ${cell.revealed ? 'revealed' : ''}`}
            onClick={() => handleCellClick(i, j)}
            onContextMenu={(e) => { e.preventDefault(); handleFlagClick(i, j); }}
          >
            {cell.revealed ? (cell.value === 0 ? '' : cell.value) : (cell.flagged ? '🚩' : '')}
          </div>
        ))}
      </div>
    ));
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>GameOn - MineSweeper</h2>
      </div>
      <div className="main-content w-7/12 mt-4">
        <div className={`minesweeper ${gameOver ? 'game-over' : ''} ${win ? 'win' : ''} top-margin justify-center`}>
          {renderGrid()}
          <div>
            <button className='w-80 flex justify-center' onClick={handleStartAgain}>Start Again</button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default GameOnMineSweeper;
